import Glide, { Controls, Swipe, Autoplay } from '@glidejs/glide/dist/glide.modular.esm'

const carousel = document.getElementById('home-hero-carousel')

if (typeof carousel !== 'undefined' && carousel) {
  const count = carousel.querySelectorAll('ul > li').length || 0

  jQuery(document).ready(() => {
    window.homeHeroSlider = new Glide(carousel, {
      type: 'carousel',
      autoplay: 10000,
      gap: 0
    })

    window.homeHeroSlider.mount(count > 1 ? { Controls, Swipe, Autoplay } : null)
  })
}



// WEBPACK FOOTER //
// ./scripts/lib/home-hero-carousel.js